// Mock data for portfolio website

export const personalInfo = {
  name: "Aditya Yadav",
  title: "Full Stack Developer",
  bio: "I am an aspiring Full Stack Developer with hands-on experience in Python, C++, and JavaScript. With a strong foundation in Data Structures & Algorithms and MySQL management, I'm skilled in creating responsive web interfaces and full-stack applications. I'm passionate about developing scalable digital solutions and have practical experience in version control with Git and GitHub.",
  email: "ay611424@gmail.com",
  phone: "+91-8852882596",
  location: "Jaipur, Rajasthan",
  linkedin: "https://linkedin.com/in/aditya-yadav-83g",
  github: "https://github.com/adityayadav",
  image: "https://customer-assets.emergentagent.com/job_64cecb61-a4c5-415c-ab00-968493445439/artifacts/389ze52v_WhatsApp%20Image%202025-11-20%20at%2001.08.32.jpeg"
};

export const education = [
  {
    id: 1,
    degree: "Bachelor of Technology (B.Tech)",
    institution: "NIMS University",
    location: "Jaipur",
    duration: "Aug 2022 - Jun 2026",
    description: "Pursuing B.Tech with focus on software development and full-stack technologies"
  },
  {
    id: 2,
    degree: "Senior Secondary (Class XII)",
    institution: "Kendriya Vidyalaya AFS Manauri",
    location: "Prayagraj, UP",
    duration: "Apr 2021 - Apr 2022"
  },
  {
    id: 3,
    degree: "Secondary (Class X)",
    institution: "Kendriya Vidyalaya AFS Manauri",
    location: "Prayagraj, UP",
    duration: "Apr 2019 - Apr 2020"
  }
];

export const experience = [
  {
    id: 1,
    title: "Python Development Intern",
    company: "Kaleidonex Technologies LLP",
    location: "Remote",
    duration: "Oct 2024 - Nov 2024",
    type: "Internship",
    responsibilities: [
      "Built GUI-based desktop tools with MySQL database support for real-time operations",
      "Implemented AES-based encryption and decryption protocols to enhance software security",
      "Improved overall performance and user experience through clean code practices"
    ]
  },
  {
    id: 2,
    title: "C++ Development Intern",
    company: "RJEasysoftech Pvt. Ltd",
    location: "Remote",
    duration: "Jul 2024 - Aug 2024",
    type: "Internship",
    responsibilities: [
      "Developed a full CRUD-based Hospital Management System in C++",
      "Reduced production errors by improving debugging and testing workflows",
      "Collaborated with senior developers to optimize existing modules"
    ]
  }
];

export const skills = {
  frontend: [
    { name: "HTML", level: 90 },
    { name: "CSS", level: 85 },
    { name: "JavaScript", level: 85 },
    { name: "React", level: 80 }
  ],
  backend: [
    { name: "Python", level: 90 },
    { name: "REST API", level: 80 },
    { name: "SQL", level: 85 },
    { name: "MongoDB", level: 75 }
  ],
  other: [
    { name: "C++", level: 85 },
    { name: "DSA", level: 80 },
    { name: "OOP", level: 85 },
    { name: "Git & GitHub", level: 85 },
    { name: "GUI Development", level: 80 }
  ]
};

export const projects = [
  {
    id: 1,
    title: "E-Commerce Website",
    description: "Developed a responsive multi-page e-commerce website using HTML, CSS, and JavaScript. Implemented product listing, shopping cart, and checkout functionality. Focused on delivering an intuitive and smooth shopping experience.",
    technologies: ["HTML", "CSS", "JavaScript"],
    image: "https://images.unsplash.com/photo-1461749280684-dccba630e2f6",
    github: "#",
    demo: "#"
  },
  {
    id: 2,
    title: "Employee Attendance System",
    description: "Created a GUI-based attendance system enabling employee check-in/out via ID and name. Implemented real-time timestamp logging to CSV for attendance tracking. Added validation and improved UI for better accuracy and experience.",
    technologies: ["Python", "GUI", "CSV"],
    image: "https://images.unsplash.com/photo-1515879218367-8466d910aaa4",
    github: "#",
    demo: "#"
  },
  {
    id: 3,
    title: "Portfolio Website",
    description: "Designed and developed a personalized, responsive portfolio website. Showcases projects, skills, and achievements in a clean, modern layout.",
    technologies: ["React", "CSS", "JavaScript"],
    image: "https://images.unsplash.com/photo-1566915896913-549d796d2166",
    github: "#",
    demo: "#"
  },
  {
    id: 4,
    title: "Hospital Management System",
    description: "Full CRUD-based Hospital Management System developed in C++. Includes patient records management, appointment scheduling, and administrative features with efficient data handling.",
    technologies: ["C++", "OOP", "File Management"],
    image: "https://images.unsplash.com/photo-1707528041466-83a325f01a3c",
    github: "#",
    demo: "#"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Senior Developer",
    position: "Tech Lead at Kaleidonex Technologies",
    image: "https://ui-avatars.com/api/?name=Senior+Developer&background=10b981&color=fff",
    text: "Aditya demonstrated excellent problem-solving skills and a strong grasp of Python development. His implementation of encryption protocols was particularly impressive."
  },
  {
    id: 2,
    name: "Project Manager",
    position: "Manager at RJEasysoftech Pvt. Ltd",
    image: "https://ui-avatars.com/api/?name=Project+Manager&background=06b6d4&color=fff",
    text: "Working with Aditya was a pleasure. He showed great dedication to the Hospital Management System project and delivered quality code with minimal supervision."
  },
  {
    id: 3,
    name: "Colleague Developer",
    position: "Full Stack Developer",
    image: "https://ui-avatars.com/api/?name=Colleague+Dev&background=f97316&color=fff",
    text: "Aditya is a quick learner with a strong foundation in DSA and OOP. His ability to understand complex requirements and translate them into working solutions is commendable."
  }
];
